"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var components_1 = require("components");
var DrawerContent_1 = require("./DrawerContent");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        cursor: 'pointer',
        userSelect: 'none',
    },
    rootItem: {
        display: 'flex',
        alignItems: 'center',
        ':hover': {
            backgroundColor: styles_1.DrawerItemColor.Hover,
        },
        ':active': {
            backgroundColor: styles_1.DrawerItemColor.Active,
        },
    },
    expandIcon: {
        width: 16,
        margin: '0 18px',
    },
};
var getStyle = function (style, props) { return ([
    style.base,
    props.style,
]); };
var DrawerSubitemsContainer = (function (_super) {
    __extends(DrawerSubitemsContainer, _super);
    function DrawerSubitemsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            _this.setState({ expanded: !_this.state.expanded });
        };
        _this.state = {
            expanded: props.expanded,
        };
        return _this;
    }
    DrawerSubitemsContainer.prototype.render = function () {
        var _a = omit(this.props, ['expanded', 'style']), children = _a.children, iconName = _a.iconName, text = _a.text, otherProps = __rest(_a, ["children", "iconName", "text"]);
        var expanded = this.state.expanded;
        return (React.createElement("div", __assign({ style: getStyle(componentStyle, this.props) }, otherProps),
            React.createElement("div", { style: componentStyle.rootItem, onClick: this.handleClick },
                React.createElement(DrawerContent_1.DrawerContent, { iconName: iconName, text: text }),
                this.renderExpandSubitemContainerIcons()),
            expanded && children));
    };
    DrawerSubitemsContainer.prototype.renderExpandSubitemContainerIcons = function () {
        var children = this.props.children;
        var expanded = this.state.expanded;
        if (!children) {
            return null;
        }
        if (expanded) {
            return React.createElement(components_1.Icon, { style: componentStyle.expandIcon, name: "expandLess" });
        }
        return React.createElement(components_1.Icon, { style: componentStyle.expandIcon, name: "expandMore" });
    };
    DrawerSubitemsContainer.defaultProps = {
        expanded: false,
        iconName: '',
        text: '',
    };
    DrawerSubitemsContainer = __decorate([
        Radium,
        __metadata("design:paramtypes", [Object])
    ], DrawerSubitemsContainer);
    return DrawerSubitemsContainer;
}(react_1.PureComponent));
exports.DrawerSubitemsContainer = DrawerSubitemsContainer;



//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer/DrawerSubitemsContainer.tsx
// module id = 292
// module chunks = 0